const rangeMin = { title: 'Min' }
const rangeMax = { title: 'Max' }

export enum ENewFilterRangeDesktop {
    MIN = 'From',
    MAX = 'To',
}

export { rangeMin, rangeMax }
